import { Injectable } from "@angular/core";

@Injectable({
  providedIn: 'root',
})
export class TextService {

  encodeText(rawText: string): string {
    // single quote ' -- 39
    let processedText: string = rawText.replaceAll(/\'/g, "&#39;");
  /*  // double quote " -- 34
    processedText = rawText.replaceAll(/\\\"/g, "&#34;");
    // tab -- 09
    processedText = rawText.replaceAll(/\t/g, "&#09;");
    // new line -- 10
    processedText = rawText.replaceAll(/\n/g, "&#10;");
    // carriage return -- 13
    processedText = rawText.replaceAll(/\r/g, "&#13;");
    // ampersand & -- 38
    processedText = rawText.replaceAll(/\&/g, "&#38;");
    // backslash \ -- 92
    processedText = rawText.replaceAll(/\\/g, "&#92;");
*/
    return processedText
  }

  decodeText(safeText: string): string {
    if (safeText) {
      // single quote ' -- 39
      let processedText: string = safeText.replaceAll(/\&\#39;/g, "'");
    /*  // double quote " -- 34
      processedText = safeText.replaceAll(/\\\"/g, '"');
      // tab -- 09
      processedText = safeText.replaceAll(/\&\#09;/g, "\t");
      // new line -- 10
      processedText = safeText.replaceAll(/\&\#10;/g, "\n");
      // carriage return -- 13
      processedText = safeText.replaceAll(/\&\#13;/g, "\r");
      // ampersand & -- 38
      processedText = safeText.replaceAll(/\&\#38;/g, "\&");
      // backslash \ -- 92
      processedText = safeText.replaceAll(/\&\#92;/g, "\\");
*/
      return processedText
    } else {
      return '';
    }

  }
}